/* global App, Libs */

(function() {
    var colors = ['#2867ac', '#be0a26', '#57ab2a', '#444', '#1bbae1', '#e67e22', '#583a63', '#d9416c'];
    var wallpaperAttached = false;
    var modalInit = false;
    var sidebarShowed = true;
    var assets = null;
    var links = function () {
        $("a").each(function () {
            if ($(this).attr("href") === "J") {
                $(this).attr("data-ajax", "off");
            }
        });
    };
    var wallpaper = function () {        
        if (!wallpaperAttached) {
            $(".dashboard-wallpaper").prependTo(document.body);
            wallpaperAttached = true;
        }
    };
    App.Ui = {
        messages: {
            unavailableData: "Nedostupná data nebo dočasně nedostupná služba. Opakujte požadavek později."
        },
        init: function () {
            $("a").on("click", function (event) {
                if ($(this).attr("href") === "J") {
                    event.preventDefault();
                    event.stopPropagation();
                }
            });
        },
        run: function () {
            var version = $("#assets-version-i").attr("data-value");
            if (assets !== null && assets !== version) {
                window.location.reload();
            }
            assets = version;
            links();
            wallpaper();
            this.signForm();
        },
        getColors: function () {
            return colors;
        },
        getWindowWidth: function () {
            return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        },
        flashMessage: function (message, type) {
            message = message || "";
            if (message.length === 0) return false;
            type = type || "success";
            var structure = '<div class="alert alert-{{type}} alert-dismissible" data-dismiss="alert"><span class="alert-close" title="Zavřít"><i class="fa fa-times"></i></span><div class="alert-icon alert-icon-{{type}}"><i class="fa fa-fw info"></i></div><div class="alert-body">{{message}}</div></div>';
            var html = Libs.Php.strtr(structure, {"{{message}}": message, "{{type}}": type});
            $("#snippet--flashMessages").html('');
            $("#snippet--flashMessages").append(html);
        },
        sidebarInit: function () {
            $('[data-toggle="client-select"]').off("click").click(function (e) {
                e.preventDefault();
                $(".clientSelectContext").toggleClass("hidden-xs");
            });
            $('[data-toggle="sidebar"]').off("click").click(function (e) {
                e.preventDefault();
                if ($("#container").hasClass("sidebar-showed")) $(this).blur();
                $("#container").toggleClass("sidebar-showed");
            });
            $('[data-toggle="navsub"]').off("click").click(function (e) {
                e.preventDefault();
                var minisidebar = $(this).parents("#sidebar-mini");
                if (minisidebar.length) {
                    $(this).blur();
                    e.stopPropagation();
                    return false;
                }
                $(this).parents("ul").find(".nav-sub").each(function() {
                    $(this).removeClass("open");
                    $(this).children("a").removeClass("active");
                });
                $(this).parents("li").addClass("open");
                $(this).addClass("active");
            });
        },
        sidebar: function (mode) {
            mode = mode || 'init';
            if (mode === 'init') {
                this.sidebarInit();
                if (this.getWindowWidth() < 991) {
                    sidebarShowed = false;
                    this.sidebar('hide');
                }
            } else if (mode === 'toggle') {
                if (sidebarShowed) {
                    sidebarShowed = false;
                    this.sidebar('hide');
                } else {
                    sidebarShowed = true;
                    this.sidebar('show');
                }
            } else if (mode === 'resize') {
                if (this.getWindowWidth() < 991) {
                    sidebarShowed = false;
                    this.sidebar('hide');
                } else {
                    sidebarShowed = true;
                    this.sidebar('show');
                }
            } else if (mode === 'hide') {
            } else if (mode === 'show') {
            }
        },
        signForm: function () {
            $(".form-sign").find(".form-group").each(function () {
                if ($(this).find(".btn").length > 0) return true;

                var description = $(this).find(".control-description");
                description.remove();

                var label = $(this).children("label").first();
                var labelText = label.text();
                var icon = label.data("icon");
                var iconHtml = '<span class="input-group-addon"><i class="fa fa-fw fa-' + icon + '"></i></span>';
                label.remove();

                var el = $(this).html();
                $(this).html("");

                $(this).prepend('<div class="input-group"></div>');
                $(this).children(".input-group").append(iconHtml);
                $(this).children(".input-group").append('<div class="form-control-container">' + el + "</div>");
                $(this).append(description);

                $(this).find("textarea").addClass("form-control").attr("placeholder", labelText);
                $(this).find('input[type="text"]').addClass("form-control").attr("placeholder", labelText);
                $(this).find('input[type="password"]').addClass("form-control").attr("placeholder", labelText);
                $(this).find('input[type="email"]').addClass("form-control").attr("placeholder", labelText);
            });
        },
        modal: function (modal, mode) {
            if (!modal) return false;
            mode = mode || "init";

            if (mode === "init") {
                let closeBtn = modal.querySelector(".close");
                if (closeBtn) closeBtn.addEventListener("click", (event) => {
                    event.preventDefault();
                    this.modal(modal, "hide");
                });
            }

            if (mode === "hide") {
                modal.style.display = "none";
                modal.dispatchEvent(new CustomEvent("hidden"));
            }

            if (mode === "show") {
                modal.style.display = "block";
                modal.dispatchEvent(new CustomEvent("shown"));
            }
        },
        widgetBlock: function (container, action) {
            container = container || $("body");
            action = action || "start";
            if (action === "start") {
                var height = container.innerHeight() - 30;
                var paddingTop = (height / 2) - 20;
                var spinner = '<div class="spinner-double-bounce"><div class="double-bounce1"></div><div class="double-bounce2"></div></div>';
                var structure = '<div class="lazyRender"><div style="height:'+height+'px;padding-top:'+paddingTop+'px;background:#fff;">' + spinner + '</div></div>';
                container.children().hide();
                container.append(structure);
            }
            if (action === "stop") {
                container.children().show();
                container.children(".lazyRender").remove();
            }
        }
    };
})();
